<template>
  <div class="page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        @submit.native.prevent
        class="query-form"
      >
        <el-row :gutter="20" class="query-row">
          <el-col v-show="queryFieldVisibility.budget_name" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
              />
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.identify_code" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.identify_code"
                clearable
                placeholder="请输入识别名称"
              />
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.keyword" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.keyword"
                clearable
                placeholder="请输入账户名称/账户ID/产品名称"
              />
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.status" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.status"
                clearable
                placeholder="聚合状态"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in AggregationStatus"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.placement_status" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.placement_status"
                clearable
                placeholder="聚合投放状态"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in AggregationCastStatus"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="queryActionSpan" class="query-item query-item--actions">
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>

              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>
              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <el-table
        stripe
        :data="table.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="200"
        />

        <el-table-column
          prop="identify_code"
          label="识别名称"
          width="300"
        >
          <template slot-scope="scope">
            <div
              style="display: flex; justify-content: space-between; width: 280px;"
              v-if="scope.row.identify_code"
            >
              <el-tag
                class="no-wrap-tag"
                type="success"
                style="margin-right: 8px;"
              >
                {{(scope.row.identify_code ? scope.row.identify_code.replace(/[，,]/g, ',').split(',') : [])[0]}}
              </el-tag>

              <el-popover
                v-if="(scope.row.identify_code ? scope.row.identify_code.replace(/[，,]/g, ',').split(',') : []).length > 1"
                placement="top"
                width="400"
                trigger="click">
                <div style="display: flex; flex-wrap: wrap; row-gap: 8px;">
                  <el-tag
                    v-bind:key="item"
                    type="success"
                    v-for="item in (scope.row.identify_code.replace(/[，,]/g, ',').split(','))"
                    style="margin-right: 8px;"
                  >
                    {{item}}
                  </el-tag>
                </div>
                <el-button slot="reference" type="text" style="flex: 1;">更多</el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="product_names"
          label="产品名称"
          width="160"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.product_names"
              style="display: flex; justify-content: space-between; width: 140px;">
              <el-tag
                class="no-wrap-tag"
                type="success"
                style="margin-right: 8px;"
              >
                {{(scope.row.product_names ? scope.row.product_names.replace(/[，,]/g, ',').split(',') : [])[0]}}
              </el-tag>

              <el-popover
                v-if="(scope.row.product_names ? scope.row.product_names.replace(/[，,]/g, ',').split(',') : []).length > 1"
                placement="top"
                width="400"
                trigger="click">
                <div style="display: flex; flex-wrap: wrap; row-gap: 8px;">
                  <el-tag
                    v-bind:key="item"
                    type="success"
                    v-for="item in (scope.row.product_names.replace(/[，,]/g, ',').split(','))"
                    style="margin-right: 8px;"
                  >
                    {{item}}
                  </el-tag>
                </div>
                <el-button slot="reference" type="text" style="flex: 1;">更多</el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="sale_type"
          label="预算类型"
          width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sale_type === '1'">直投</div>
            <div v-else-if="scope.row.sale_type === '2'">渠道</div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="聚合状态"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == '1'" type="success">有效</el-tag>
            <el-tag v-else-if="scope.row.status == '0'" type="info">失效</el-tag>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="placement_status"
          label="聚合投放状态"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.placement_status == '1'" type="success">在投</el-tag>
            <el-tag v-else-if="scope.row.placement_status == '0'" type="info">停投</el-tag>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="owner_name"
          label="归属"
          width="120"
        />

         <template #empty>
          <div style="display: flex; align-items: center; justify-content: center; padding: 30px;">
            <el-empty
              description="请输入筛选条件查询"
              :image-size="100"
            />
          </div>
        </template>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { FormDialog } from '@/components';
import queryGridByContainer from '@/common/js/queryGridByContainer';

const req = new Request();
let self;
export default {
  name: 'AggregationManageMy',
  components: { FormDialog },
  data() {
    return {
      userInfo: {},
      ProductOptions: [],
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          budget_name: '',
          page: 1,
          page_size: 10,
          identify_code: '', // 识别名称
          keyword: '', // 销售名称
          status: '',
          placement_status: ''
        },
      },
      queryExpanded: true,
      AggregationStatus: [
        {label: '有效', value: '1'},
        {label: '失效', value: '0'},
      ],
      AggregationCastStatus: [
        {label: '在投', value: '1'},
        {label: '停投', value: '0'}
      ]
    };
  },
  mixins: [queryGridByContainer],
  computed: {
    SaleTypeOptions() {
      return [
        {label: '直投', value: '1'},
        {label: '渠道', value: '2'},
      ]
    },

    perms() {
      return this.$store.state.perms;
    },

    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },
    collapsedQueryCount() {
      return Math.min(Math.max(this.queryColumnsPerRow - 1, 1), this.queryFieldKeys.length);
    },
    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },
    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns = remainder === 0
        ? this.queryColumnsPerRow
        : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      const keys = ['budget_name', 'identify_code', 'keyword', 'status' , 'placement_status'];
      return keys
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },
  },
  created() {
    // this._getList();
  },
  methods: {
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    async handleSearchProducts(val){
      const res = await req.send(req.Apis.customer.productSeries.products, {
        names: val,
        page: 1,
        page_size: 100,
      });
      if(res.code === 200) {
        const {data} = res;
        this.ProductOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
    },

    // 获取用户列表数据
    async _getList(option = {}) {
      try {
        let _query = this.query.form;
        const params = {
          ..._query,
          ...option
        };

        this.table.loading = true;

        const res = await req
          .send(req.Apis.sales.customerStage2.belong, params)
          .fin(() => {
            this.table.loading = false;
          });
        const dv = res.data || {};
        this.table.list = [...(dv.data || [])];
        this.table.total = Number(dv.total || 0);
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },


    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    handleReset() {
      this.query.form.budget_name = '';
      this.query.form.identify_code = '';
      this.query.form.keyword = '';
      this.query.form.status = '';
      this.query.form.placement_status = '';
      this.query.form.page = 1;
    },
    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },
  },
};

</script>

<style lang="less" scoped>
.query-conditions {
  margin-bottom: 24px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}

.query-row {
  flex: 1 1 720px;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

.query-extra-actions {
  flex: 1 1 300px;
  min-width: 300px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-start;
}

.query-extra-buttons {
  margin-left: 12px;
}

/deep/ .query-conditions .el-form-item {
  display: block;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-conditions .el-form-item__content {
  display: block;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

.query-data {
  // table
  .query-table {
    position: relative;
    overflow: hidden;
  }
}
.no-wrap-tag {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media screen and (max-width: 767px) {
  .query-extra-actions {
    min-width: 100%;
    justify-content: flex-start;
  }

  .query-extra-buttons {
    margin-top: 12px;
    margin-left: 0;
  }
}
</style>
